(function () {
  function parseVariants(root) {
    var source = root.querySelector("[data-vc-product-variants]");
    if (!source) return [];

    try {
      return JSON.parse(source.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function getSelectedOptions(inputs) {
    var selected = [];
    inputs.forEach(function (input) {
      if (!input.checked) return;
      selected[Number(input.dataset.optionPosition) - 1] = input.value;
    });
    return selected;
  }

  function optionsMatch(variant, selected) {
    return variant.options.every(function (value, index) {
      return selected[index] === value;
    });
  }

  function findVariant(variants, selected) {
    return variants.find(function (variant) {
      return optionsMatch(variant, selected);
    }) || null;
  }

  function findAvailableVariantForChange(variants, selected, changedPosition) {
    var bestVariant = null;
    var bestMatchCount = -1;

    variants.forEach(function (variant) {
      if (!variant.available || variant.options[changedPosition] !== selected[changedPosition]) return;

      var matchCount = variant.options.reduce(function (count, value, index) {
        return count + (selected[index] === value ? 1 : 0);
      }, 0);

      if (matchCount > bestMatchCount) {
        bestVariant = variant;
        bestMatchCount = matchCount;
      }
    });

    return bestVariant;
  }

  function autoplayMedia(panel) {
    var video = panel.querySelector("video");
    if (!video) return;
    video.controls = false;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      video.controls = true;
      return;
    }
    video.muted = true;
    var playback = video.play();
    if (playback && playback.catch) playback.catch(function () {
      // Let shoppers start playback themselves when autoplay is blocked.
      video.controls = true;
    });
  }

  function setMainImage(root, mediaId) {
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-vc-product-media]"));
    var selected = panels.find(function (panel) {
      return panel.dataset.mediaId === String(mediaId);
    });
    if (!selected) return;

    panels.forEach(function (panel) {
      var active = panel === selected;
      var wasHidden = panel.hidden;
      panel.hidden = !active;
      var video = panel.querySelector("video");
      if (!active && video) video.pause();
      if (active && wasHidden) autoplayMedia(panel);
    });

    root.querySelectorAll("[data-vc-product-thumbnail]").forEach(function (thumbnail) {
      var active = thumbnail.dataset.mediaId === String(mediaId);
      thumbnail.classList.toggle("is-active", active);
      thumbnail.setAttribute("aria-current", active ? "true" : "false");
    });
  }

  function syncExtraOption(root) {
    var nativeSelected = root.querySelector("[data-vc-native-extra-option] [data-vc-product-option-input]:checked");
    if (nativeSelected) {
      root.querySelectorAll("[data-vc-extra-input]").forEach(function (input) {
        input.checked = input.value === nativeSelected.value;
      });
    }
    var extraSelected = root.querySelector("[data-vc-extra-input]:checked");
    var selectedLabel = root.querySelector("[data-vc-extra-selected]");
    if (extraSelected && selectedLabel) selectedLabel.textContent = extraSelected.value;
  }

  function initQuantity(root) {
    var input = root.querySelector("[data-vc-quantity-input]");
    var minus = root.querySelector("[data-vc-quantity-minus]");
    var plus = root.querySelector("[data-vc-quantity-plus]");
    if (!input || !minus || !plus) return;

    function normalizeQuantity(value) {
      var parsed = Number(value);
      if (!Number.isFinite(parsed) || parsed < 1) return 1;
      return Math.floor(parsed);
    }

    minus.addEventListener("click", function () {
      input.value = String(Math.max(1, normalizeQuantity(input.value) - 1));
    });

    plus.addEventListener("click", function () {
      input.value = String(normalizeQuantity(input.value) + 1);
    });

    input.addEventListener("change", function () {
      input.value = String(normalizeQuantity(input.value));
    });
  }

  function initGallery(root) {
    root.querySelectorAll("[data-vc-product-media]").forEach(function (panel) {
      if (!panel.hidden) autoplayMedia(panel);
    });
    root.querySelectorAll("[data-vc-product-thumbnail]").forEach(function (thumbnail) {
      thumbnail.addEventListener("click", function () {
        setMainImage(root, thumbnail.dataset.mediaId);
      });
    });
  }

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-vc-product-tab]"));
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-vc-product-panel]"));
    if (!tabs.length || !panels.length) return;

    function activate(target) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.vcProductTab === target;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });

      panels.forEach(function (panel) {
        var active = panel.dataset.vcProductPanel === target;
        panel.classList.toggle("is-active", active);
        panel.hidden = !active;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activate(tab.dataset.vcProductTab);
      });
    });
  }

  function initVariants(root) {
    if (root.dataset.vcComingSoon === "true") return;
    var variants = parseVariants(root);
    var inputs = Array.prototype.slice.call(root.querySelectorAll("[data-vc-product-option-input]"));
    var idInput = root.querySelector("[data-vc-product-variant-id]");
    var price = root.querySelector("[data-vc-product-price]");
    var comparePrice = root.querySelector("[data-vc-product-compare-price]");
    var priceRange = root.querySelector("[data-vc-product-price-range]");
    var addButton = root.querySelector("[data-vc-product-add-button]");
    var soldOutOverlay = root.querySelector("[data-vc-product-sold-out-overlay]");
    var productForm = root.querySelector(".vc-product-form");
    var personalizationWrapper = root.querySelector("[data-vc-product-personalization]");
    var personalizationInput = root.querySelector("[data-vc-product-personalization-input]");

    if (!variants.length || !idInput) return;

    function refreshOptionAvailability() {
      inputs.forEach(function (input) {
        var position = Number(input.dataset.optionPosition) - 1;

        var hasAvailableVariant = variants.some(function (variant) {
          return variant.available && variant.options[position] === input.value;
        });

        input.disabled = !hasAvailableVariant;
      });
    }

    function syncInputsToVariant(variant) {
      inputs.forEach(function (input) {
        var position = Number(input.dataset.optionPosition) - 1;
        input.checked = variant.options[position] === input.value;
      });
    }

    function syncPersonalization(variant) {
      if (!personalizationWrapper || !personalizationInput) return;
      var requiresPersonalization = Boolean(variant.requiresPersonalization);
      personalizationWrapper.hidden = !requiresPersonalization;
      personalizationInput.disabled = !requiresPersonalization;
      personalizationInput.required = requiresPersonalization;
      if (!requiresPersonalization) personalizationInput.setCustomValidity("");
    }

    function update(changedInput) {
      var selected = getSelectedOptions(inputs);
      var variant = findVariant(variants, selected);

      if (changedInput && (!variant || !variant.available)) {
        var changedPosition = Number(changedInput.dataset.optionPosition) - 1;
        variant = findAvailableVariantForChange(variants, selected, changedPosition);
      }

      if (!variant) return;

      syncInputsToVariant(variant);
      syncExtraOption(root);
      idInput.value = variant.id;
      syncPersonalization(variant);
      var iconChoice = variant.options.find(function (value) { return /^\+[234] icons$/i.test(value); });
      var iconCount = iconChoice ? Number(iconChoice.charAt(1)) : 2;
      root.querySelectorAll("[data-vc-tote-icon]").forEach(function (wrapper) {
        var active = Number(wrapper.dataset.vcToteIcon) <= iconCount;
        var select = wrapper.querySelector("select");
        wrapper.hidden = !active;
        select.disabled = !active;
        select.required = active;
      });

      if (price) price.textContent = variant.price;
      if (comparePrice) {
        comparePrice.textContent = variant.compareAtPrice || "";
        comparePrice.hidden = !variant.compareAtPrice;
      }
      if (priceRange) priceRange.hidden = Boolean(variant.compareAtPrice);

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? "Buy now" : "Out of stock";
      }

      if (soldOutOverlay) soldOutOverlay.hidden = variant.available;

      if (variant.featuredImage) {
        setMainImage(root, variant.featuredMediaId);
      }

      inputs.forEach(function (input) {
        if (!input.checked) return;
        var label = root.querySelector('[data-vc-selected-option="' + input.dataset.optionPosition + '"]');
        if (label) label.textContent = input.value;
      });

      refreshOptionAvailability();
    }

    if (productForm && personalizationInput) {
      personalizationInput.addEventListener("input", function () {
        if (personalizationInput.value.trim()) {
          personalizationInput.setCustomValidity("");
        }
      });

      productForm.addEventListener("submit", function (event) {
        if (personalizationInput.disabled) return;
        var value = personalizationInput.value.trim();
        if (value) {
          personalizationInput.value = value;
          personalizationInput.setCustomValidity("");
          return;
        }
        personalizationInput.setCustomValidity("Enter personalization text.");
        event.preventDefault();
        personalizationInput.reportValidity();
      }, true);
    }

    inputs.forEach(function (input) {
      input.addEventListener("change", function () {
        update(input);
      });
    });

    update();
  }

  function initProduct(root) {
    if (root.dataset.vcProductInitialized === "true") return;
    root.dataset.vcProductInitialized = "true";

    root.querySelectorAll("[data-vc-extra-input]").forEach(function (input) {
      input.addEventListener("change", function () {
        var selected = root.querySelector("[data-vc-extra-selected]");
        if (selected) selected.textContent = input.value;
        var nativeInput = Array.prototype.slice.call(root.querySelectorAll("[data-vc-native-extra-option] [data-vc-product-option-input]")).find(function (candidate) {
          return candidate.value === input.value;
        });
        if (nativeInput && root.dataset.vcComingSoon !== "true") {
          nativeInput.checked = true;
          nativeInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });

    syncExtraOption(root);

    // Send the same line-item properties through the app's registry form.
    // The registry service still owns persistence and downstream gift checkout.
    var productForm = root.querySelector(".vc-product-form");
    function prepareRegistryForm(event) {
      var target = event.target;
      if (!target || !target.closest || !productForm) return;
      var registryForm = event.type === "submit" ? target : target.closest("form");
      var registryMount = root.querySelector("#AddToRegistryTarget");
      if (!registryForm || registryForm === productForm || !registryMount || !registryMount.contains(registryForm)) return;
      if (event.type === "click" && !target.closest('button[type="submit"], input[type="submit"]')) return;
      if (root.dataset.vcComingSoon === "true" || !productForm.reportValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      registryForm.querySelectorAll("[data-vc-registry-property]").forEach(function (input) { input.remove(); });
      new FormData(productForm).forEach(function (value, name) {
        if (name.indexOf("properties[") !== 0 || typeof value !== "string") return;
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        input.dataset.vcRegistryProperty = "true";
        registryForm.appendChild(input);
      });
    }
    root.addEventListener("submit", prepareRegistryForm, true);
    root.addEventListener("click", prepareRegistryForm, true);

    initGallery(root);
    if (root.dataset.vcComingSoon === "true") {
      var form = root.querySelector(".vc-product-form");
      if (form) form.addEventListener("submit", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    } else {
      initQuantity(root);
    }
    initTabs(root);
    initVariants(root);
  }

  function initAllProducts() {
    document.querySelectorAll("[data-vc-product]").forEach(initProduct);
  }

  document.addEventListener("DOMContentLoaded", initAllProducts);
  document.addEventListener("shopify:section:load", initAllProducts);
})();
